import React from "react";
import { useNavigate } from "react-router-dom";
import { Warning } from "@phosphor-icons/react";

const KEY = "age_verified_v1";
export const isAgeVerified = () => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };

export default function AgeGate({ onAccept }) {
  const navigate = useNavigate();
  const accept = () => { try { localStorage.setItem(KEY, "1"); } catch {} onAccept?.(); };
  return (
    <div className="fixed inset-0 z-[90] bg-black/75 flex items-center justify-center p-4" data-testid="age-gate">
      <div className="bg-white rounded-lg nb-shadow-lg max-w-sm w-full p-6 text-center">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mx-auto"><Warning weight="fill" size={30} className="text-primary" /></div>
        <h2 className="text-xl font-extrabold tracking-tight mt-4">Contenido para adultos (+18)</h2>
        <p className="text-sm text-muted-foreground mt-2">Este contenido es solo para mayores de 18 años. Al continuar declaras ser mayor de edad.</p>
        <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-3 py-2 mt-3">Importante: los productos para adultos <b>no tienen garantía</b>.</p>
        <div className="flex gap-2 mt-6">
          <button onClick={() => navigate("/")} data-testid="age-gate-reject" className="flex-1 nb-btn bg-secondary py-2.5 text-sm">Salir</button>
          <button onClick={accept} data-testid="age-gate-accept" className="flex-1 nb-btn bg-primary text-primary-foreground py-2.5 text-sm hover:brightness-110">Soy mayor de edad</button>
        </div>
      </div>
    </div>
  );
}
